<script>
import moment from 'moment'

export default {
    props: {
        attempt_number: {
            type: String,
            required: true
        },
        session: {
            type: String,
            required: true
        }
    },
    created() {

        this.getItems()
    },
    mounted() {
        window.setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000);
        },1000);
    },
    data: () => ({
        tabPosition: 'bottom',
        loading: false,
        visibleGoodJob: false,
        visibleEnded: false,
        items: {
            exam: {
                questions: []
            }
        },
        dateString: null,
        now: Math.trunc((new Date()).getTime() / 1000)
    }),
    computed: {
        date() {
            return this.dateString
        },
        classExamSession(){
            return this.items.session != null ? this.items.session : {}
        },
        dateInMilliseconds() {
            return Math.trunc(Date.parse(this.date) / 1000)
        },
        seconds() {
            return (this.dateInMilliseconds - this.now) % 60;
        },
        minutes() {
            return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
        },
        hours() {
            return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
        },
        days() {
            return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
        },
        questions() {
            return this.items.exam_questions != null ? this.items.exam_questions.questions : []
        },
        examNav(){
            return this.items.exam_questions != null ? this.items.exam_questions.nav : []
        },
        answered() {
            var arrContent = this.questions.filter(function(ele){
                return ele.answered != null
            });

            return arrContent.length
        },
        attempt(){
            return this.items.exam_questions != null ? this.items.exam_questions.attempt : ""
        }
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam-questions.attempt", {session: this.session}),{
                    params: {
                        attempt_number: this.attempt_number,
                    }
                })
                .then(response => {
                    if(response.data.session.actual_exam_time_end != null && this.attempt_number == 1){
                        this.ended()
                    }else if(response.data.session.actual_remid_time_end != null && this.attempt_number == 2){
                        this.ended()
                    }else{
                        this.items = response.data
                    }
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        nextQuestion(){
            this.$refs.question.next();
        },
        backQuestion(){
            this.$refs.question.prev();
        },
        goto(index){
            this.$refs.question.goTo(index, true);
        },
        nextNav(){
            this.$refs.questionnav.next();
        },
        backNav(){
            this.$refs.questionnav.prev();
        },
        answer(hash, index){
            this.questions[index].answered = hash
        },
        done() {
            this.loading = true
            this.$http.patch(this.routeUri('api.classical-exam-questions.done',
                {
                    attempt: this.attempt
                }
            ))
                .then(() => {
                    this.goodJob()
                })
                .catch((e) => this.handleResponseError(e.response.data))
                .finally(() => this.loading = false)
        },
        showConfirm() {
            var msg = 'Akhiri ujian?'

            if(this.answered < this.questions){
                var rest = (parseInt(this.questions)-parseInt(this.answered))
                msg = rest + ' soal belum terjawab!!! Lanjutkan akhiri ujian?'
            }

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.done()
                },
                onCancel() {},
                class: 'test',
            });
        },
        ended(){
            this.visibleEnded = true
        },
        goodJob(){
            this.visibleGoodJob = true
        },
        closed(){
            window.location.replace(this.routeUri('admin.classical.attendant.exam.session'))
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal",
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        }
    },
    watch: {
        items: function(value) {
            var actual_time_start = value.session.is_remid_open == true ? value.session.actual_remid_time_start : value.session.actual_exam_time_start
            this.dateString = moment(actual_time_start, 'YYYY-MM-DD HH:mm:ss')
                    .add(value.session.exam_duration, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
    },
    filters: {
        two_digits: function (value) {
            if (value < 0) {
                return '00';
            }
            if (value.toString().length <= 1) {
                return `0${value}`;
            }
            return value;
        },
    }
}
</script>
<template>
    <div style="height: 100%">
        <a-card size="small">
            <a-row type="flex">
                <a-col :span="24">
                    <a-descriptions bordered>
                        <a-descriptions-item label="Ujian">
                            {{ classExamSession.name }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Jadwal ujian">
                            {{ moment(classExamSession.exam_time_start).format('DD MMMM YYYY HH:mm:ss') }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Durasi">
                            <div v-if="classExamSession.exam_duration != undefined">
                                {{ classExamSession.exam_duration + ' Menit' }}
                            </div>
                        </a-descriptions-item>
                        <a-descriptions-item label="Soal terjawab">
                            <strong>{{ answered }}/{{ questions.length }}</strong>
                        </a-descriptions-item>
                        <a-descriptions-item label="Waktu Tersisa">
                            <div v-if="date != null">
                                <strong>{{ hours | two_digits }}:{{ minutes | two_digits }}:{{ seconds | two_digits }}</strong>
                            </div>
                        </a-descriptions-item>
                    </a-descriptions>
                </a-col>
            </a-row>
        </a-card>

        <a-skeleton :loading="loading" active>
            <a-row type="flex" :gutter="8" style="margin-top:20px">
                <a-col :span="17">
                    <a-carousel ref="question" :dots="false" effect="fade">
                        <template v-for="(question, index) in questions">
                            <question-multi-choice
                                :attempt="attempt"
                                :question="question"
                                :index="index"
                                :class_exam_session="classExamSession"
                                :question_length="questions.length"
                                @answer="answer"
                                @next="nextQuestion" @back="backQuestion"
                                @showConfirm="showConfirm"
                                @ended="ended" />
                        </template>
                    </a-carousel>
                </a-col>
                <a-col :span="7">
                    <a-card size="small">
                        <strong>Nomor soal</strong><br>
                        <a-carousel ref="questionnav" :dots="false" effect="fade">
                            <template v-for="(nav, indexParent) in examNav">
                                <div>
                                    <template v-for="(item, indexChild) in nav">
                                        <a-button size="small" style="margin-right: 10px;margin-top: 10px;width: 50px;background: #87d068;color: #ffffff"
                                            @click="() => goto(item.qid)"
                                            :key="`${item.qid+1}`"
                                            :ref="`${item.qid+1}`"
                                            v-if="questions[item.qid].answered != null">{{ item.qid+1}} </a-button>

                                            <a-button size="small" style="margin-right: 10px;margin-top: 10px;width: 50px;background: #E1E1E1"
                                            @click="() => goto(item.qid)"
                                            :key="`${item.qid+1}`"
                                            :ref="`${item.qid+1}`"
                                            v-else>{{ item.qid+1}} </a-button>
                                    </template>
                                </div>
                            </template>
                        </a-carousel>
                        <a-row type="flex" style="margin-top: 30px" justify="space-around" align="middle">
                            <a-col align="center">
                                <a-button type="primary" size="small" @click="backNav"> <a-icon type="left" /></a-button>
                                <a-button type="primary" size="small" @click="nextNav" style="margin-top:4px"><a-icon type="right" /> </a-button>
                            </a-col>
                        </a-row>
                    </a-card>
                </a-col>
            </a-row>
        </a-skeleton>

        <a-modal
            :visible="visibleEnded"
            :destroyOnClose="true"
            :footer="null"
            :closable="false">

            <a-result
                status="error"
                title="Waktu ujian sudah habis"
                sub-title="">
                <template #extra>
                    <a-button type="primary" @click="closed">
                        Tutup
                    </a-button>
                </template>
            </a-result>
        </a-modal>

        <a-modal
            :visible="visibleGoodJob"
            :destroyOnClose="true"
            :footer="null"
            :closable="false">

            <a-result title="Great, good job!">
                <template #icon>
                    <a-icon type="smile" theme="twoTone" />
                </template>
                <template #extra>
                    <a-button type="primary" @click="closed">
                        Tutup
                    </a-button>
                </template>
            </a-result>
        </a-modal>
    </div>
</template>
<style scoped>
.countdown {
  display: flex;
  align-items: center;
    display: flex;
    justify-content: center;
}

.block {
    display: flex;
    flex-direction: column;
    margin: 10px;
}

.text {
    color: #000;
    font-size: 25px;
    font-family: 'Roboto Condensed', serif;
    text-align: center;
}

.digit {
    color: #000;
    font-size: 30px;
    font-family: 'Roboto', serif;
    text-align: center;
}
</style>
